import React, { useEffect, useState } from 'react';
import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Typography,
  CircularProgress,
  Button,
} from '@mui/material';
import axios from 'axios';
import SuperAdminLayout from '../../../layouts/SuperAdminLayout';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import api from '../../../utils/api';

const ProductPurchaseReport = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const user = JSON.parse(localStorage.getItem('user'));

  useEffect(() => {
    const fetchReport = async () => {
      try {
        const res = await api.get(`api/reports/product-purchase/${user.id}`);
        setData(res.data);
      } catch (err) {
        console.error('Error fetching product-wise sales report:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchReport();
  }, [user.id]);

  const exportToExcel = (data, fileName) => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

    const excelBuffer = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });

    const blob = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    saveAs(blob, `${fileName}.xlsx`);
  };

  return (
    <SuperAdminLayout>
      <Typography variant="h6" sx={{ mt: 2 }}>
        Product-wise Purchase Report
      </Typography>

      <Button
        variant="contained"
        color="success"
        sx={{ mb: 2 }}
        onClick={() => exportToExcel(data, 'Product_Purchase_Report')}
      >
        Download Excel
      </Button>
      {loading ? (
        <CircularProgress />
      ) : (
        <TableContainer component={Paper} sx={{ mt: 2 }}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Product Name</TableCell>
                <TableCell>Quantity</TableCell>
                <TableCell>Rate</TableCell>
                <TableCell>Total</TableCell>
                <TableCell>Date</TableCell>
                <TableCell>Invoice #</TableCell>
                <TableCell>Party Name</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row, idx) => (
                <TableRow key={idx}>
                  <TableCell>{row.productName}</TableCell>
                  <TableCell>{row.quantity}</TableCell>
                  <TableCell>₹{row.rate}</TableCell>
                  <TableCell>₹{row.total}</TableCell>
                  <TableCell>{row.date}</TableCell>
                  <TableCell>{row.challanNumber}</TableCell>
                  <TableCell>{row.partyName}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </SuperAdminLayout>
  );
};

export default ProductPurchaseReport;
